import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/chat-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-7fd239a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scroll"
}
const _hoisted_2 = {
  key: 1,
  class: "message-btns"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-group-add" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-invite" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "scroll"
}
const _hoisted_6 = {
  key: 1,
  class: "message-btns"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "d-background__image",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "d-background__title" }, "CaseDrive for Desktop"),
  /*#__PURE__*/_createElementVNode("p", { class: "d-background__text" }, "Send and receive messages without using your phone all the time.")
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_messages_conversations = _resolveComponent("messages-conversations")!
  const _component_message_group_chat_create = _resolveComponent("message-group-chat-create")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_refresh_pull, {
          modelValue: _ctx.loadingPull,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loadingPull) = $event)),
          onRefresh: _ctx.onRefresh,
          successText: _ctx.successText,
          pullingText: _ctx.pullingText,
          loosingText: _ctx.loosingText,
          loadingText: _ctx.loadingText,
          disabled: (_ctx.createGroup && !_ctx.noData) || _ctx.isGroupInfoOpen
        }, {
          default: _withCtx(() => [
            (_ctx.noData && _ctx.mainStore.isMobile)
              ? (_openBlock(), _createBlock(_component_app_no_message, {
                  key: 0,
                  icon: _ctx.hasData ? 'icon-not-found' : 'icon-no-data'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hasData ? 'No search results found.' : 'You don’t have any contacts/messages/groups yet.'), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]))
              : _createCommentVNode("", true),
            (!_ctx.noData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.mainStore.isMobile)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createGroup = true)),
                        class: "group-chat-create"
                      }, [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.create.group')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mainStore.isNative)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "tell-a-friend",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shareApp && _ctx.shareApp(...args)))
                      }, [
                        _hoisted_4,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$localize('app.menu.share_app')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.messagesStore.filteredConversations.length && _ctx.mainStore.isMobile)
              ? (_openBlock(), _createBlock(_component_messages_conversations, {
                  key: 2,
                  conversation: _ctx.messagesStore.conversations,
                  onOpenGroupInfo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isGroupInfoOpen = true)),
                  onCloseGroupInfo: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isGroupInfoOpen = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('messages.last.messages')), 1)
                  ]),
                  _: 1
                }, 8, ["conversation"]))
              : _createCommentVNode("", true),
            (_ctx.createGroup && !_ctx.noData)
              ? (_openBlock(), _createBlock(_component_message_group_chat_create, {
                  key: 3,
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createGroup = false))
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText", "disabled"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.noData && _ctx.mainStore.isMobile)
          ? (_openBlock(), _createBlock(_component_app_no_message, {
              key: 0,
              icon: _ctx.hasData ? 'icon-not-found' : 'icon-no-data'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.hasData ? 'No search results found.' : 'You don’t have any contacts/messages/groups yet.'), 1)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true),
        (!_ctx.noData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.messagesStore.filteredConversations.length && _ctx.mainStore.isMobile)
          ? (_openBlock(), _createBlock(_component_messages_conversations, {
              key: 2,
              conversation: _ctx.messagesStore.conversations
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('messages.last.messages')), 1)
              ]),
              _: 1
            }, 8, ["conversation"]))
          : _createCommentVNode("", true)
      ]))
}